import accentureLogo from '@assets/partner-logos/accenture.svg';
import amazonLogo from '@assets/partner-logos/amazon.svg';
import barclaysLogo from '@assets/partner-logos/barclays.svg';
import blinkitLogo from '@assets/partner-logos/blinkit.svg';
import cventLogo from '@assets/partner-logos/cvent.svg';
import deloitteLogo from '@assets/partner-logos/deloitte-digital.jpeg';
import deltaLogo from '@assets/partner-logos/delta-airline.png';
import dxcLogo from '@assets/partner-logos/DXC.svg';
import emiratesLogo from '@assets/partner-logos/emirates.svg';
import freshworksLogo from '@assets/partner-logos/freshworks.svg';
import globantLogo from '@assets/partner-logos/globant.svg';
import godrejLogo from '@assets/partner-logos/godrej.svg';
import hclLogo from '@assets/partner-logos/hcl.svg';
import idfcLogo from '@assets/partner-logos/idfc-bank.svg';
import infosysLogo from '@assets/partner-logos/infosys.svg';
import makeMyTripLogo from '@assets/partner-logos/makemytrip.svg';
import microsoftLogo from '@assets/partner-logos/microsoft.svg';
import mongodbLogo from '@assets/partner-logos/mongodb.svg';
import sapLogo from '@assets/partner-logos/sap.svg';
import seimensLogo from '@assets/partner-logos/seimens.svg';
import timesGroupLogo from '@assets/partner-logos/times-group.svg';
import wellsFargoLogo from '@assets/partner-logos/wells-fargo.png';
import zeptoLogo from '@assets/partner-logos/zepto.svg';

export const logos = [
    microsoftLogo,
    makeMyTripLogo,
    accentureLogo,
    amazonLogo,
    globantLogo,
    freshworksLogo,
    dxcLogo,
    zeptoLogo,
    hclLogo,
    mongodbLogo,
    cventLogo,
    barclaysLogo,
    blinkitLogo,
    deloitteLogo,
    deltaLogo,
    emiratesLogo,
    godrejLogo,
    idfcLogo,
    infosysLogo,
    sapLogo,
    seimensLogo,
    wellsFargoLogo,
    timesGroupLogo
];